const config = {
	API_ROOT: "https://api.bis-apps.com/ServiceLayer/b1s/v2/",
};

export default config;
